module.exports = __webpack_public_path__ + "static/media/Confluence_Domain_url.4b372502.png";